module.exports = __webpack_public_path__ + "static/img/David.Hille.b6bd826.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/David.Hille.jpg
// module id = tIcK
// module chunks = 0